if (typeof DynaCore_FormConfig_Settings == "undefined") {
    var DynaCore_FormConfig_Settings =
    {
        /**
         * Upraveni nastaveni elementu formulare
         *
         * @param element
         * @param partName
         * @param partId
         * @param subPartName
         * @param subPartId
         */
        edit: function(element, partName, partId, subPartName, subPartId)
        {
            var url = '/core/form-config/settings' + '?_ch=' + $('#_ch').val() + '&parNam=' + partName + '&parId=' + partId;

            if (typeof subPartName != 'undefined') {
                url +=  '&subParNam=' + subPartName;
                url +=  '&subParId=' + subPartId;
            }

            // Panel
            var elementType = partName.substring(0, partName.length-1);

            if ('rows' == partName || 'cols' == partName || 'tabs' == partName) {
                var elementPanel = $(element).children('.el-' + elementType + '-card');
            } else {
                var elementPanel = $(element).parent().parent('.el-' + elementType + '-card');
            }

            $(document).load(url, function(form) {
                Lemo_Modal.setTitle('Settings');
                Lemo_Modal.setContent(form);
                Lemo_Modal.addButton('change', '<i class="fas fa-fw fa-check"></i> ' + translate('Change'), 'btn btn-primary', function() {
                    $.ajax({
                        type: 'post',
                        url: url,
                        data: $('#modal :input').serialize(),
                        dataType: "json",
                        success: function(data) {
                            $(element).removeClass('mt-0 mt-1 mt-2 mt-3 mt-4 mt-5 mt-auto');
                            $(element).removeClass('mb-0 mb-1 mb-2 mb-3 mb-4 mb-5 mb-auto');
                            $(element).removeClass('ml-0 ml-1 ml-2 ml-3 ml-4 ml-5 ml-auto');
                            $(element).removeClass('mr-0 mr-1 mr-2 mr-3 mr-4 mr-5 mr-auto');
                            $(element).removeClass('text-danger text-dark text-info text-light text-muted text-primary text-secondary text-success text-warning');
                            $(element).removeClass('text-left text-center text-justify font-weight-bold text-italic text-underline');

                            // HTML obsah elementu
                            if ($(elementPanel).length > 0) {
                                var elementHtml = $(elementPanel).find('.card-body').html();
                            } else {
                                var elementHtml = element.outerHTML;
                            }

                            if (true === data.card) {
                                var classCard = 'card';
                                var classCardHeader = 'card-header';

                                // STYLE - Ramecek
                                if ('' !== data.cardColor) {
                                    classCard += ' border-' + data.cardColor;
                                }

                                classCard += ' el-' + elementType + '-card';

                                // STYLE - Margin
                                if (null !== data.styleMarginTop) {
                                    classCard += ' mt-' + data.styleMarginTop;
                                }
                                if (null !== data.styleMarginBottom) {
                                    classCard += ' mb-' + data.styleMarginBottom;
                                }
                                if (null !== data.styleMarginLeft) {
                                    classCard += ' ml-' + data.styleMarginLeft;
                                }
                                if (null !== data.styleMarginRight) {
                                    classCard += ' mr-' + data.styleMarginRight;
                                }

                                // STYLE - Heading
                                if ('' !== data.cardColor) {
                                    classCardHeader += ' bg-' + data.cardColor;
                                    classCardHeader += ' border-' + data.cardColor;
                                }
                                if (null != data.cardHeadingColor) {
                                    classCardHeader += ' text-' + data.cardHeadingColor;
                                }
                                if (null != data.cardHeadingAlign) {
                                    classCardHeader += ' text-' + data.cardHeadingAlign;
                                }
                                if (true == data.cardHeadingBold) {
                                    classCardHeader += ' font-weight-bold';
                                }
                                if (true == data.cardHeadingItalic) {
                                    classCardHeader += ' font-italic';
                                }
                                if (true == data.cardHeadingUnderline) {
                                    classCardHeader += ' text-underline';
                                }

                                // Panel jiz existuje, budeme menit jen aktualni DOM / Pridame novy card
                                if ($(elementPanel).length > 0) {

                                    // Class
                                    $(elementPanel).attr('class', classCard);

                                    // Nadpis
                                    if (null == data.cardHeader || '' == data.cardHeader) {
                                        $(elementPanel).find('.card-header').remove();
                                    } else {
                                        if ($(elementPanel).find('.card-header').length > 0) {
                                            $(elementPanel).find('.card-header').text(data.cardHeader).attr('class', classCardHeader);
                                        } else {
                                            $(elementPanel).prepend('<div class="' + classCardHeader + '">' + data.cardHeader + '</div>');
                                        }
                                    }
                                } else {
                                    var heading = '';
                                    if (null != data.cardHeader) {
                                        heading += '<div class="' + classCardHeader + '">' + data.cardHeader + '</div>';
                                    }

                                    if ('rows' == partName || 'cols' == partName || 'tabs' == partName) {
                                        if ($(elementPanel).length > 0) {
                                            var elementHtml = $(elementPanel).children('.card-body').html();
                                        } else {
                                            var elementHtml = $(element).html();
                                        }

                                        $(element).html('<div class="' + classCard + '">' + heading + '<div class="card-body">' + elementHtml + '</div>');
                                    } else {
                                        $('<div class="' + classCard + '">' + heading + '<div class="card-body">' + elementHtml + '</div>').insertBefore(element);
                                        $(element).remove();
                                    }
                                }
                            } else {

                                // Panel existuje, odebereme ho
                                if ($(elementPanel).length > 0) {
                                    if ('rows' == partName || 'cols' == partName || 'tabs' == partName) {
                                        $(element).html($(elementPanel).children('.card-body').html());
                                    } else {
                                        $(elementPanel).replaceWith(elementHtml);
                                    }
                                }

                                // STYLE - Margin
                                if (null !== data.styleMarginTop) {
                                    $(element).addClass('mt-' + data.styleMarginTop);
                                }
                                if (null !== data.styleMarginBottom) {
                                    $(element).addClass('mb-' + data.styleMarginBottom);
                                }
                                if (null !== data.styleMarginLeft) {
                                    $(element).addClass('ml-' + data.styleMarginLeft);
                                }
                                if (null !== data.styleMarginRight) {
                                    $(element).addClass('mr-' + data.styleMarginRight);
                                }
                            }

                            // STYLE - Text
                            if (null != data.styleTextColor) {
                                $(element).addClass('text-' + data.styleTextColor);
                            }
                            if (null != data.styleTextAlign) {
                                $(element).addClass('text-' + data.styleTextAlign);
                            }
                            if (true == data.styleTextBold) {
                                $(element).addClass('font-weight-bold');
                            }
                            if (true == data.styleTextItalic) {
                                $(element).addClass('font-italic');
                            }
                            if (true == data.styleTextUnderline) {
                                $(element).addClass('text-underline');
                            }

                            DynaCore_FormConfig_Button.init();
                            DynaCore_FormConfig_ButtonToolbar.init();
                            DynaCore_FormConfig_Col.init();
                            DynaCore_FormConfig_Content.init();
                            DynaCore_FormConfig_Form.init();
                            DynaCore_FormConfig_Grid.init();
                            DynaCore_FormConfig_Heading.init();
                            DynaCore_FormConfig_Miniform.init();
                            DynaCore_FormConfig_Row.init();
                            DynaCore_FormConfig_Tab.init();
                            DynaCore_FormConfig_Text.init();
                            Lemo_Alert.addSuccess('Settings have been successfully updated');
                            Lemo_Modal.close();
                        },
                        error: function(html) {
                            Lemo_Alert.addDanger('Some form fields are not filled up or not filled correctly');

                            $('#dialogBody').html(html.responseText);
                        }
                    });
                });
                Lemo_Modal.addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Close'), 'btn btn-secondary', function() {
                    Lemo_Modal.close();
                });
                Lemo_Modal.build();
                DynaBase_Tabs.init();
            });
        }
    }
}
